const navLinks = [
  { label: "About", id: "about" },
  { label: "Rooms", id: "rooms" },
  { label: "Amenities", id: "amenities" },
  { label: "House Rules", id: "house-rules" },
  { label: "Gallery", id: "gallery" },
  { label: "Location", id: "location" },
  { label: "Booking", id: "booking" },
];

export default function Footer({ onNav }: { onNav: (id: string) => void }) {
  return (
    <footer className="py-20" style={{ backgroundColor: "#28200E" }}>
      <div className="max-w-7xl mx-auto px-10 md:px-16">
        {/* Brand */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 pb-16" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          <div>
            <span className="font-serif font-medium tracking-[0.25em]" style={{ fontSize: "2.2rem", color: "#D5C4A8", textShadow: "0 1px 2px rgba(0,0,0,0.15)" }}>Rietkuil</span>
            <p className="text-sm tracking-[0.2em] uppercase font-sans font-medium mt-2" style={{ color: "rgba(255,255,255,0.45)" }}>FARMHOUSE· NEAR BOTHAVILLE · FREE STATE, SOUTH AFRICA</p>
          </div>
          <p className="font-sans font-light leading-loose text-sm max-w-xs md:text-right" style={{ color: "rgba(255,255,255,0.3)" }}>
            A third-generation working farm. Space, stillness, and wide open skies — all yours.
          </p>
        </div>

        {/* Links + contact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div>
            <h4 className="text-sm font-sans font-medium uppercase tracking-[0.2em] mb-6" style={{ color: "rgba(255,255,255,0.4)" }}>Navigate</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button onClick={() => onNav(link.id)}
                    className="text-sm font-sans font-light cursor-pointer tracking-wide transition-colors"
                    style={{ color: "rgba(255,255,255,0.35)" }}
                    onMouseEnter={e => (e.currentTarget.style.color = "#D5C4A8")}
                    onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-sans font-medium uppercase tracking-[0.2em] mb-6" style={{ color: "rgba(255,255,255,0.4)" }}>Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.2)" }}></i>
                <span className="text-sm font-sans font-light leading-relaxed" style={{ color: "rgba(255,255,255,0.35)" }}>Near Bothaville<br />Northern Free State, South Africa</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-sm" style={{ color: "rgba(255,255,255,0.2)" }}></i>
                <div>
                  <a href="tel:+27839481845" className="text-sm font-sans font-light transition-colors block" style={{ color: "rgba(255,255,255,0.35)" }}
                    onMouseEnter={e => (e.currentTarget.style.color = "#D5C4A8")}
                    onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}>
                    083 948 1845
                  </a>
                  <a href="tel:+27836426660" className="text-sm font-sans font-light transition-colors block" style={{ color: "rgba(255,255,255,0.35)" }}
                    onMouseEnter={e => (e.currentTarget.style.color = "#D5C4A8")}
                    onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}>
                    Alt. 083 642 6660
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-sm" style={{ color: "rgba(255,255,255,0.2)" }}></i>
                <a href="mailto:tanja@btbits.co.za" className="text-sm font-sans font-light transition-colors" style={{ color: "rgba(255,255,255,0.35)" }}
                  onMouseEnter={e => (e.currentTarget.style.color = "#D5C4A8")}
                  onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}>
                  tanja@btbits.co.za
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-sm" style={{ color: "rgba(255,255,255,0.2)" }}></i>
                <a href="https://www.instagram.com/rietkuil_farm_house/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer" className="text-sm font-sans font-light transition-colors" style={{ color: "rgba(255,255,255,0.35)" }}
                  onMouseEnter={e => (e.currentTarget.style.color = "#D5C4A8")}
                  onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}>
                  @rietkuil_farm_house
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-sans font-medium uppercase tracking-[0.2em] mb-6" style={{ color: "rgba(255,255,255,0.4)" }}>Quick Info</h4>
            <ul className="space-y-3">
              {[
                "\u00a0\nSleeps 10 guests max",
                "4 bedrooms + separate room",
                "Self-catering",
                "Pet friendly · All ages welcome",
                "Min. 2-night stay (weekends)",
              ].map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm font-sans font-medium" style={{ color: "rgba(255,255,255,0.5)" }}>
                  <div className="w-1 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: "rgba(255,255,255,0.2)" }}></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8" style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}>
          <p className="text-sm font-sans font-medium" style={{ color: "rgba(255,255,255,0.35)" }}>© 2026 Rietkuil Farmhouse · Near Bothaville · Free State, South Africa · Est. 2012</p>
          <p className="text-sm font-sans font-medium" style={{ color: "rgba(255,255,255,0.35)" }}>A peaceful experience in the heart of the Free State countryside</p>
        </div>
      </div>
    </footer>
  );
}
